import { apiDelete, apiGet, apiPatch } from '@/shared/utils/requestBuilder';
import type {
  EscritorioMembro,
  ListarMembrosFilters,
  UpdatePapelDto,
} from '@/types/escritorio/escritorioTypes';

export const escritorioMembrosService = {
  listar: async (
    escritorioId: string,
    filters?: ListarMembrosFilters,
  ): Promise<EscritorioMembro[]> => {
    try {
      const params = new URLSearchParams();
      if (filters?.papel) params.append('papel', filters.papel);
      if (filters?.ativo !== undefined) params.append('ativo', String(filters.ativo));

      const query = params.toString() ? `?${params.toString()}` : '';
      const endpoint = `/escritorios/${escritorioId}/membros${query}`;

      console.log('🔍 Requisitando membros:', endpoint);
      const response = await apiGet(endpoint);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Erro ao listar membros' }));
        console.error('❌ Erro na resposta ao listar membros:', {
          status: response.status,
          errorData,
        });
        throw new Error(errorData.error || 'Erro ao listar membros');
      }

      const data = await response.json();
      console.log('✅ Membros listados com sucesso:', data.data?.length || 0);
      return data.data;
    } catch (error) {
      console.error('❌ Exceção ao listar membros:', error);
      throw error;
    }
  },

  updatePapel: async (
    escritorioId: string,
    membroId: string,
    data: UpdatePapelDto,
  ): Promise<EscritorioMembro> => {
    const response = await apiPatch(`/escritorios/${escritorioId}/membros/${membroId}/papel`, data);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao atualizar papel' }));
      throw new Error(errorData.error || 'Erro ao atualizar papel do membro');
    }

    const result = await response.json();
    return result.data;
  },

  toggleStatus: async (escritorioId: string, membroId: string): Promise<EscritorioMembro> => {
    const response = await apiPatch(`/escritorios/${escritorioId}/membros/${membroId}/status`, {});

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao alterar status' }));
      throw new Error(errorData.error || 'Erro ao alterar status do membro');
    }

    const result = await response.json();
    return result.data;
  },

  remover: async (escritorioId: string, membroId: string): Promise<void> => {
    const response = await apiDelete(`/escritorios/${escritorioId}/membros/${membroId}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao remover membro' }));
      throw new Error(errorData.error || 'Erro ao remover membro');
    }
  },
};
